/**
 * @file Détermine si le formulaire porte des coordonnées client exploitables.
 * @module packages.common.components.table-reservation.utils.contactValidity
 *
 * Source unique partagée par le sync du brouillon et le préchargement de
 * l'intent Stripe : les deux n'ont de sens qu'avec un contact identifiable
 * (nom complet et un email valide ou un téléphone). La règle d'email est la
 * même que celle du backend (brouillon, liste d'attente).
 */

/** Même validation d'email que l'étape CONTACT côté backend (waitlist/draft) */
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Indique si les coordonnées saisies identifient le client.
 *
 * @param {Object} formData - État du formulaire (firstName, lastName, email, phone)
 * @return {boolean} true si nom complet et email valide ou téléphone présent
 */
export function hasValidContact(formData) {
  const {firstName, lastName, email, phone} = formData || {};
  return Boolean(firstName) && Boolean(lastName) &&
    (EMAIL_REGEX.test((email || '').trim()) || Boolean((phone || '').trim()));
}
